import React from "react";

const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(255,255,255,0.95)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 99999,
  },

  wrapper: {
    position: "relative",
    width: "140px",
    height: "140px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },

  logo: {
    width: "50px",
    height: "50px",
    zIndex: 2,
  },

  spinner: {
    position: "absolute",
    width: "140px",
    height: "140px",
    borderRadius: "50%",
    border: "1px solid #e6e6e6",
    borderTop: "1px solid #2f80ed",
    borderRight: "2px solid #2f80ed",
    animation: "spin 1.2s linear infinite",
  },
};

export default function GlobalLogoLoader() {
  return (
    <div style={styles.overlay}>
      <div style={styles.wrapper}>
        <div style={styles.spinner}></div>
        <img src="/preloader-logo.png" alt="loading" style={styles.logo} />
      </div>
    </div>
  );
}